import { Brand, createBranded } from '@deltasierra/type-utilities';
import React from 'react';

type ForceReRender = Brand<Record<string, unknown>, 'ForceReRender'>;
const ForceReRender = createBranded<ForceReRender>();

/**
 * These are the props available to force re-renders
 */
export type ForceReRenderableProps = {
    forceReRenderProp?: ForceReRender;
};

/**
 * This function can help re-render the dropdown when the input size changes
 *
 * @returns The re-render props for the component to re-render
 */
export function useForceRerender(): [reRenderProps: ForceReRenderableProps, forceReRender: () => void] {
    const [force, setForce] = React.useState(ForceReRender.from({}));
    const forceReRender = React.useCallback(() => {
        setForce(ForceReRender.from({}));
    }, []);
    return [{ forceReRenderProp: force }, forceReRender];
}
